import React from 'react';
import { ServicePage } from '../ServicePage';

const CONFIG = {
  title: 'Réparation Tablette Villeurbanne / Lyon — iPad, Galaxy Tab & Surface | PHONELAB 69',
  metaDescription: '✅ Réparation tablette iPad, Samsung Galaxy Tab & Microsoft Surface — Villeurbanne / Lyon. Écran, batterie, connecteur. Expertise Surface unique. Diagnostic GRATUIT. ☎ 04 26 00 82 10',
  icon: '📟',
  badge: 'Spécialiste Tablettes — Villeurbanne / Lyon',
  h1: 'Réparation Tablettes\nVilleurbanne & Lyon',
  subtitle: 'iPad, Samsung Galaxy Tab et Microsoft Surface réparés avec précision. Composants haute fidélité, expertise spécifique par marque, garantie jusqu\'à 12 mois.',
  stats: [
    { icon: '🍎', label: 'iPad toutes générations' },
    { icon: '📲', label: 'Galaxy Tab S & A' },
    { icon: '💻', label: 'Surface Pro & Go' },
    { icon: '🛡️', label: 'Garantie jusqu\'à 12 mois' },
  ],
  servicesTitle: 'Réparations tablettes disponibles à Villeurbanne',
  services: [
    {
      icon: '📺',
      name: 'Remplacement écran iPad',
      models: 'iPad Air, Pro 11", Pro 12.9", Mini 5/6, iPad standard 9e/10e génération',
      duration: '1 à 2h',
    },
    {
      icon: '📺',
      name: 'Remplacement écran Samsung Galaxy Tab',
      models: 'Tab A7, A8, S6 Lite, S7, S7+, S8, S8+, S9, S9 Ultra',
      duration: '45 min à 1h30',
    },
    {
      icon: '💻',
      name: 'Réparation Microsoft Surface',
      models: 'Surface Pro (3→9), Go, Laptop, Book — protocole d\'ouverture spécifique maîtrisé',
      duration: '24-48h',
    },
    {
      icon: '🔋',
      name: 'Remplacement batterie tablette',
      models: 'iPad, Galaxy Tab, Surface, Huawei MediaPad — autonomie restaurée à 100%',
      duration: '30 à 60 min',
    },
    {
      icon: '⚡',
      name: 'Connecteur de charge USB-C / Lightning',
      models: 'Port qui ne charge plus, câble qui ne tient pas',
      duration: '30 à 45 min',
    },
    {
      icon: '🔘',
      name: 'Bouton Home & Touch ID (iPad)',
      models: 'iPad ancienne génération — bouton Home défaillant ou cassé',
      duration: '30 min',
    },
    {
      icon: '📷',
      name: 'Réparation caméra tablette',
      models: 'Caméra avant / arrière floue ou non fonctionnelle',
      duration: '30 à 45 min',
    },
    {
      icon: '🔊',
      name: 'Haut-parleurs & microphone',
      models: 'Son absent, crachotant ou micro ne capte plus',
      duration: '30 min',
    },
    {
      icon: '💧',
      name: 'Désoxydation tablette',
      models: 'Nettoyage ultrason après contact avec l\'eau',
      duration: '1 à 2h',
    },
  ],
  guarantee: {
    duration: 'Garantie 6 à 12 mois',
    label: 'Dalles LCD/OLED haute fidélité',
    speed: 'Express ou sous 48h',
  },
  faq: [
    {
      q: 'Combien coûte la réparation d\'un écran iPad à Villeurbanne ?',
      a: 'Le tarif varie selon le modèle d\'iPad (mini, standard, Air, Pro) et la qualité de la dalle choisie. Les dalles Rétina d\'origine ou haute fidélité garantissent une qualité visuelle identique à l\'original. Diagnostic 100% gratuit — venez nous voir au 6 Rue Paul Verlaine ou appelez le 04 26 00 82 10 pour un devis immédiat.',
    },
    {
      q: 'Vous réparez vraiment les Microsoft Surface à Villeurbanne ?',
      a: 'Oui, et c\'est une de nos spécialités rares sur Lyon Métropole. La gamme Microsoft Surface (Pro, Go, Laptop, Book) nécessite un protocole d\'ouverture spécifique — le châssis est collé et une mauvaise manipulation détruit la dalle ou les nappes. PHONELAB 69 maîtrise ce protocole pour chaque référence Surface. Délai : 24 à 48h selon la panne.',
    },
    {
      q: 'Ma tablette Samsung Galaxy Tab ne s\'allume plus — que faire ?',
      a: 'Ne la chargez pas trop longtemps et amenez-la rapidement. Un Galaxy Tab qui ne s\'allume plus peut avoir une batterie profondément déchargée (très récupérable), un problème de connecteur de charge ou une panne carte mère. Notre diagnostic gratuit identifie la cause en 15 minutes.',
    },
    {
      q: 'Garantie sur la réparation de ma tablette ?',
      a: 'La garantie dépend de la pièce : 12 mois sur les dalles d\'origine (Service Pack), 6 mois sur les compatibles premium certifiées. En cas d\'immobilisation de plus de 7 jours chez nous, la garantie est automatiquement prolongée (Art. L217-11 Code Consommation). Toujours par écrit.',
    },
    {
      q: 'Réparez-vous les tablettes Huawei et Lenovo à Villeurbanne ?',
      a: 'Oui, PHONELAB 69 répare également les tablettes Huawei (MatePad, MediaPad) et Lenovo (Tab M10, P11). Pour les modèles moins courants, les pièces peuvent être commandées sous 48 à 72h. Appelez-nous pour vérifier la disponibilité.',
    },
  ],
  ctaTitle: 'Votre tablette réparée avec précision',
  ctaSubtitle: 'Diagnostic gratuit · Expertise Surface unique · Garantie écrite',
};

export default function TabletPage() {
  return <ServicePage config={CONFIG} />;
}
